/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Findings_BodyInputs */



/**
* | output |
* | --- |
* | "Names the channels, roles and invite links behind a change, and the newcomers nobody answered." |
*
* @param {Features_Findings_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_findings_body = /** @type {((inputs?: Features_Findings_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Findings_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Называют каналы, роли и ссылки-приглашения, которые стоят за изменением, и новичков, которым никто не ответил.")
	return /** @type {LocalizedString} */ ("Names the channels, roles and invite links behind a change, and the newcomers nobody answered.")
});